{
	"apiVersion": 3,
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"name": "core/icon",
	"title": "Icon",
	"category": "media",
	"description": "Insert an SVG icon.",
	"keywords": [ "icon", "svg" ],
	"textdomain": "default",
	"attributes": {
		"icon": {
			"type": "string",
			"role": "content"
		},
		"flipHorizontal": {
			"type": "boolean",
			"default": false
		},
		"flipVertical": {
			"type": "boolean",
			"default": false
		},
		"rotation": {
			"type": "number",
			"default": 0
		}
	},
	"supports": {
		"anchor": true,
		"ariaLabel": {
			"__experimentalSkipSerialization": true
		},
		"align": [ "left", "center", "right" ],
		"background": {
			"backgroundImage": true,
			"backgroundSize": true,
			"gradient": true,
			"__experimentalSkipSerialization": true
		},
		"html": false,
		"color": {
			"__experimentalSkipSerialization": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"shadow": {
			"__experimentalSkipSerialization": true
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalSkipSerialization": true,
			"__experimentalDefaultControls": {
				"color": false,
				"radius": false,
				"style": false,
				"width": false
			}
		},
		"spacing": {
			"padding": true,
			"margin": true,
			"__experimentalSkipSerialization": [ "padding" ],
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"dimensions": {
			"width": true,
			"minWidth": true,
			"minHeight": true,
			"__experimentalSkipSerialization": [
				"width",
				"minWidth",
				"minHeight"
			],
			"__experimentalDefaultControls": {
				"width": true
			}
		}
	},
	"selectors": {
		"root": ".wp-block-icon svg",
		"css": ".wp-block-icon",
		"shadow": ".wp-block-icon svg",
		"spacing": {
			"margin": ".wp-block-icon"
		}
	},
	"style": "wp-block-icon",
	"editorStyle": "wp-block-icon-editor"
}
